import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import PlantBackground from "components/Layouts/PlantBackground";
import Email from "components/common/Email";
import {
  showFailureNotification,
  showSuccessNotification,
} from "store/actions/notification";
import { cognitoForgotPassword } from "services/cognitoAuth";

import styles from "./ResetPassword.module.css";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const changeEmail = (e) => {
    const withoutSpaces = e.target.value.replace(/\s/g, "");
    setEmail(withoutSpaces);
  };

  const requestReset = async () => {
    if (!email.length) {
      dispatch(showFailureNotification("The email field is empty"));
      return;
    }
    setLoading(true);
    try {
      await cognitoForgotPassword(email);
      dispatch(
        showSuccessNotification(
          "If an account exists, a verification code has been sent."
        )
      );
      history.push(`/confirm-reset?email=${encodeURIComponent(email)}`);
    } catch (e) {
      // Cognito returns the same error for unknown user / disabled etc. — keep generic message.
      dispatch(
        showFailureNotification(e?.message || "Failed to start password reset")
      );
    } finally {
      setLoading(false);
    }
  };

  const onKeyUp = (e) => {
    if (e.key === "Enter") requestReset();
  };

  return (
    <PlantBackground>
      <div className={styles.container} onKeyUp={onKeyUp}>
        <div className={styles.formContainer}>
          <label className={styles.label}>Reset Password</label>
          <div className={styles.form}>
            <Email change={changeEmail} email={email} />
            <footer className={styles.footer}>
              <button
                onClick={requestReset}
                className={styles.submit}
                type="button"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send code"}
              </button>
            </footer>
          </div>
        </div>
      </div>
    </PlantBackground>
  );
};

export default ResetPassword;
